import { TARGET_GROUPS } from "../../lib/data";

export default function TargetGroups() {
  return (
    <section data-testid="target-groups-section" className="py-24 md:py-32 bg-[#F8F5EF]">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-6 reveal">
            <div className="flex items-center gap-3 mb-6">
              
              <span className="overline">Für wen</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#1A1A1A] tracking-tight">
              Für die, die <br />
              Immobilien <span className="italic font-light">ernst</span> <span className="gold-text italic">nehmen</span>.
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 md:pt-12 reveal">
            <p className="text-[15px] leading-relaxed text-[#5A5A5A] font-light">
              Wertbild arbeitet für Profis und Eigentümer, die wissen: ein gepflegtes Bild
              eines gepflegten Objekts ist der wichtigste Vermarktungs&shy;hebel.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#EAE6DE] border border-[#EAE6DE]">
          {TARGET_GROUPS.map((t, i) => (
            <div
              key={t.title}
              data-testid={`target-group-${i}`}
              className={`bg-[#F8F5EF] p-8 md:p-10 hover:bg-white transition-colors duration-500 reveal ${
                i % 2 === 1 ? "lg:bg-[#FAF7F1]" : ""
              }`}
            >
              <div className="flex items-baseline justify-between mb-6">
                <span className="ticker-num text-3xl gold-text">0{i + 1}</span>
                <span className="w-6 h-px bg-[#1A1A1A]/15"></span>
              </div>
              <h3 className="font-display text-2xl md:text-[28px] text-[#1A1A1A] tracking-tight">
                {t.title}
              </h3>
              <p className="mt-4 text-[14px] leading-relaxed text-[#5A5A5A] font-light">
                {t.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
